"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Microphone = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 10,
  viewBox: "0 0 16 10"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0.217987 1.09202C0 1.51984 0 2.0799 0 3.2V6.8C0 7.9201 0 8.48016 0.217987 8.90798C0.409734 9.28431 0.715695 9.59027 1.09202 9.78201C1.51984 10 2.07989 10 3.2 10H7.8C8.9201 10 9.48016 10 9.90798 9.78201C10.2843 9.59027 10.5903 9.28431 10.782 8.90798C11 8.48016 11 7.9201 11 6.8V3.2C11 2.0799 11 1.51984 10.782 1.09202C10.5903 0.715695 10.2843 0.409734 9.90798 0.217987C9.48016 0 8.9201 0 7.8 0H3.2C2.0799 0 1.51984 0 1.09202 0.217987C0.715695 0.409734 0.409734 0.715695 0.217987 1.09202ZM12 6.93864V3.05246L15.6667 1.02175C15.8222 0.956253 16 1.04354 16 1.21825V8.77278C16 8.94749 15.8222 9.05656 15.6667 8.96928L12 6.93864Z",
  className: "fill"
}));
var _default = exports.default = Microphone;